var map = {
	"./img_0.png": 497,
	"./img_1.png": 498,
	"./img_2.png": 499,
	"./img_3.png": 500,
	"./img_4.png": 501,
	"./img_5.png": 502,
	"./img_6.png": 503,
	"./img_7.png": 504,
	"./img_8.png": 505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;